import { render, staticRenderFns } from "./BaseConfig.vue?vue&type=template&id=7452cdfd"
import script from "./BaseConfig.vue?vue&type=script&lang=js"
export * from "./BaseConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports